import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-dolgu-farklari/page.tsx");
